import TroubleshootIcon from '@mui/icons-material/Troubleshoot'
import {IconButton, Tooltip} from '@mui/material'
import type {GridRowModel} from '@mui/x-data-grid'
import type {FC, ReactElement} from 'react'
import {NavLink} from 'react-router-dom'
import type {AnomalyWithReasonInterface} from '@shared/interfaces/anomaly'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import {buildAnomalyExplorerUrl} from '@containers/Dashboards/Anomalies/anomalyNavigation'

interface Props {
  row: GridRowModel
}

// Opens the Signal Explorer overlaying the anomaly's program with exactly its
// batch picked and its signal plotted (AB#5931 phase 2) — see
// anomalyNavigation.ts for why the old classic-page link broke.
const GoToAnomaly: FC<Props> = ({row}): ReactElement => {
  const [t] = useCustomTranslation('anomalies')

  return (
    <Tooltip title={t('go_to_anomaly')}>
      <NavLink
        to={buildAnomalyExplorerUrl(row as AnomalyWithReasonInterface, Date.now())}
        data-cy="mbai-go-to-anomaly"
      >
        <IconButton data-testid="mbai-go-to-anomaly-button">
          <TroubleshootIcon />
        </IconButton>
      </NavLink>
    </Tooltip>
  )
}

export default GoToAnomaly
